// "My desk: R TCO 2 · ext 205" / "Pick your desk" (CU-869fmcc9r). Opens the
// desk picker (pick, change, release; a clash offers Take over). Shown to
// everyone the backend lets pick a desk (Call Logs users), whether or not they
// can start calls.
import PropTypes from 'prop-types';
import { Chip, Tooltip } from '@mui/material';
import Iconify from '../Iconify';
import { useOutbound } from './OutboundCallProvider';
import { deskLabel, deskSummary, isSharedSetup } from './outboundModel';

export const myDeskLabel = (desk) => (desk ? `My desk: ${deskSummary(desk)}` : 'Pick your desk');

// `compact` (app header): only once a desk is held, named short ("R TCO 2"); where the
// sign-in desk pill collapses to (CU-869fmdxu8).
export default function MyDeskChip({ sx, compact }) {
    const outbound = useOutbound();
    if (!outbound?.canPickDesk) return null;
    const { myDesk } = outbound;
    if (compact && !myDesk) return null;
    // Shared handsets ("Anyone uses any phone"): nobody sits at one desk, Call asks which
    // handset instead, so no "Pick your desk". A desk they already hold still shows.
    if (!myDesk && isSharedSetup(outbound.desks)) return null;
    return (
        <Tooltip title={myDesk ? `${compact ? `My desk: ${deskSummary(myDesk)} · ` : ''}Calls to this desk pop up for you · change or release` :'Tell the CRM which desk phone you\'re at, so its calls pop up for you'}>
            <Chip
                icon={<Iconify icon="mdi:deskphone" width={18} />}
                label={compact ? deskLabel(myDesk) : myDeskLabel(myDesk)}
                size={compact ? 'small' : 'medium'}
                variant={myDesk ? 'filled' : 'outlined'}
                color={myDesk ? 'primary' : 'default'}
                onClick={() => outbound.openDeskPicker()}
                data-testid={compact ? 'header-desk-chip' : 'my-desk-chip'}
                sx={{ fontWeight: 600, ...sx }}
            />
        </Tooltip>
    );
}

MyDeskChip.propTypes = { sx: PropTypes.object, compact: PropTypes.bool };
